import classNames from "classnames";
import IconImagePlaceholder from "@assets/ic-post-image-placeholder.svg?.react";
import styles from "./index.module.scss";

const LazyImage = ({
  src,
  height,
  imageClassName,
  wrapperClassName,
  onClick,
  children,
  placeholderImage = IconImagePlaceholder,
  isSubsDetails,
  onlyBgImage,
  showBackdrop,
  PlaceholderComponent = null,
}) => (
  <div
    style={{ "--max-height": `${height}px !important` }}
    className={classNames(
      "position-relative d-flex",
      styles.imagePlaceholder,
      wrapperClassName,
    )}
  >
    {showBackdrop && <div className={styles.backdrop} />}
    {children}
    {!onlyBgImage && (
      <picture
        onClick={onClick}
        className={classNames(
          "d-flex w-100 justify-content-center align-items-center",
          styles.image,
        )}
      >
        <source data-srcset={src} srcSet={src} />

        {PlaceholderComponent ? (
          PlaceholderComponent
        ) : (
          <img
            className={classNames("lazyload mw-100 m-0", imageClassName)}
            src={placeholderImage}
            alt="Post content"
          />
        )}
      </picture>
    )}
    <img
      alt="Post content"
      src={src}
      className={classNames(
        "position-absolute lazyload",
        styles.bgImage,
        isSubsDetails && styles.blur10,
      )}
    />
  </div>
);

export default LazyImage;
